import type { FaireProductEntity } from "../../entity_types/product";

export const p_389c2pc6rk: FaireProductEntity = {
  token: "p_389c2pc6rk",
  type: "product",
  name: "Pedestal Bird Bath Cast Iron Green Patina Garden Decor",
  brandName: "Iron & Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/f0008e24794790b158a48aebf0048b426ac8a674aab11a985e27ff721f332573.jpeg",
  priceDollars: 24.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/df2bb9a3d6d724ed0d5b18a0513de3c54099c07a1ed3104c37d3acee0f045b37.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
